import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-log-events',
  templateUrl: './log-events.component.html',
  styleUrls: ['./log-events.component.scss']
})
export class LogEventsComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
